import * as React from 'react';
import { defineValueForSelectOptionPayment, formatDateHeure, formatNumCommande, getEtatCommande } from './OrderAction';
import { Credit, Order, PaymentMethod } from './iMonCompte';
import {formatPrice, getBoutiqueColor, getShopRefInStorage, getUserId} from './MonCompteAction';
import Icons from './Icons';
import { Link } from 'react-router-dom';
import { getShopInfosInStorage } from '../cart/ShopInfos';
import {getHostApi} from '../../utils';
import { ProductViewer } from '@dp/product-customizer-components';

// eslint-disable-next-line
declare var moment: any;

export const renderFilArianne = (link: any, text: string) => {
  const displayLink = () => {
    if (link !== '') {
      return (
        <span className="text-underline">
          <Icons icon="keyboard_arrow_right" size={10} color="black"/>&nbsp;
          {link}
        </span>
      );
    }
  };

  const url = () => {
    if (getShopRefInStorage() === 'DT' || getShopRefInStorage() === 'TH') {
      return '/account/';
    }
    return '/www/MonCompte/moncompte.php';
  };

  return (
    <div>
      <p className="grey mb-3">
        <a href={url()} className="grey text-underline">Mon compte</a>&nbsp;
        {displayLink()}
        &nbsp; <Icons icon="keyboard_arrow_right" size={10} color="black"/>&nbsp;{text}
      </p>
    </div>
  );
};

export const renderAlert = (showAlert: boolean, classAlert: string, text: string) => {
  if (showAlert) {
    return (
      <div className={'d-flex alert my-3 font-14 ' + classAlert} role="alert">
        {text}
      </div>
    );
  }
};

export const renderLabel = (label: string) => {
  return (
    <label className="col-md-6 text-right">{label}</label>
  );
};

export const defineRequiredInput = (name: string) => {
  if (name === 'libelle' || name === 'prenom' || name === 'nom' || name === 'adresse' || name === 'code_postal'
    || name === 'ville' || name === 'pays' || name === 'telephone_mobile') {
    return true;
  }
  return false;
};

export const renderInput = (type: string, name: string, value: any,
                            onChange: (event: any) => void,
                            classToAdd: string | null = null) => {
  let checked = false;
  let strAutoComplete = 'off';
  let classOrigin = name !== 'activatePanachage' && name !== 'comment' && name!=='droits' ? 'col-md-6 text-left ' : '';
  let maxLengthVal = 3000;
  if ((type === 'checkbox' && value === '1')) {
    checked = true;
  }

  if (name === 'societe') {
    strAutoComplete = 'no';
  }

  if (name === 'adresse' || name === 'adresse2' || name === 'societe') {
    maxLengthVal = 30;
  }
  if (name === 'nom') {
    maxLengthVal = 14;
  }
  if (name === 'prenom') {
    maxLengthVal = 12;
  }

  if (name === 'bic') {
    maxLengthVal = 11;
  }

  if (type === 'checkbox' && classToAdd !== 'checkBoxRGPD') {
    classToAdd += ' col-2 ';
    if( name==='droits'){
      classToAdd = ' pl-0 mr-2 ';
    }
  }
  if(classToAdd === 'checkBoxRGPD') {
    classOrigin = '';
  }
  const onPasteCallback = (event: React.SyntheticEvent) => {
    if (type === 'email' && name === 'confirmEmail') {
      event.preventDefault();
    }
  };

  return (
    <div className={classOrigin+ ' ' + classToAdd}>
      <input id={name} onChange={onChange} type={type} name={name} value={value} autoComplete={strAutoComplete} checked={checked}
             onPaste={onPasteCallback} required={defineRequiredInput(name)} min="0"  maxLength={maxLengthVal} className=""/>
    </div>
  );
};

export const isBatEnCours = (
  statut: string,
  validationBat: string,
  confirmationFichier: string,
  marquageClair: boolean) => {
  return parseInt(statut) === 5
    && parseInt(validationBat) === 0
    && parseInt(confirmationFichier) !== 0
    && !marquageClair
    && (getShopRefInStorage() === 'TE' || getShopRefInStorage() === 'TO');
};

export const isBatAttenteValidation = (
  statut: string,
  validationBat: string,
  confirmationFichier: string,
  marquageClair: boolean) => {
  return parseInt(statut) === 5
    && parseInt(validationBat) === 1
    && parseInt(confirmationFichier) !== 0
    && !marquageClair
    && (getShopRefInStorage() === 'TE' || getShopRefInStorage() === 'TO' || getShopRefInStorage() === 'TH');
};

export const isFichierAttenteValidation = (statut: string, confirmationFichier: string) => {
  return parseInt(statut) === 5
    && parseInt(confirmationFichier) === 0
    && (getShopRefInStorage() === 'TE' || getShopRefInStorage() === 'TO' || getShopRefInStorage() === 'DT' || getShopRefInStorage() === 'TH');
};

export const renderEtatCommande = (
  statut: string,
  etat: string,
  validationBat: string,
  confirmationFichier: string,
  marquageClair: boolean,
  aucunMarquage: boolean) => {

  const statutInt = parseInt(statut);

  const defineClass = () => {
    let classEtat = '#333';

    if (statutInt === 9) {
      classEtat = '#333';
    } else if (statutInt === 8) {
      classEtat = 'green';
    } else if (statutInt < 4
      || isFichierAttenteValidation(statut, confirmationFichier)
      || isBatAttenteValidation(statut, validationBat, confirmationFichier, marquageClair)) {
      classEtat = 'orange';
    } else if (statutInt <= 5 || statutInt >= 7) {
      classEtat = '#333';
    }

    return classEtat;
  };

  const defineIcon = () => {
    if (statutInt !== 9) {
      if (statutInt < 4
        || isFichierAttenteValidation(statut, confirmationFichier)
        || isBatAttenteValidation(statut, validationBat, confirmationFichier, marquageClair)) {
        return (<Icons icon="hourglass_empty" size={16} color="#f68909"/>);
      }
      if (statutInt === 8) {
        return (<Icons icon="local_shipping" size={16} color="#73ad22"/>);
      }
      if (statutInt === 5 || statutInt === 6) {
        return (<Icons icon="engrenage" size={16} color="#333"/>);
      }
      if (statutInt === 7) {
        return (<Icons icon="colis" size={16} color="#333"/>);
      }

    }
  };

  let newEtat = etat;
  if (statutInt === 5 && (getShopRefInStorage() === 'MT' || (getShopRefInStorage() === 'TH' && aucunMarquage))) {
    newEtat = 'En cours de préparation';
  } else if (isFichierAttenteValidation(statut, confirmationFichier)) {
    newEtat = 'En attente de vos fichiers';
  } else if (isBatAttenteValidation(statut, validationBat, confirmationFichier, marquageClair)) {
    newEtat = 'Attente validation BAT';
  } else if (isBatEnCours(statut, validationBat, confirmationFichier, marquageClair)) {
    newEtat = 'BAT en cours';
  }

  return (
    <div className={'italic pa0Mobile ' + defineClass()}>
      {defineIcon()}
      <span className="pl-1">
        {getEtatCommande(newEtat)}
      </span>
    </div>
  );
};

export const renderNumCommande = (numCommande: string) => {
  if (numCommande) {
    return (
      <span className="numCommande">{formatNumCommande(numCommande)}</span>
    );
  }

};

export const renderDateCommande = (numCommande: string, date: string, text: string) => {
  if (numCommande !== '') {
    return (
      <div className="black">
        <span className="bold">{text} : </span>{formatDateHeure(date)}
      </div>
    );
  }
};

export const renderMontantTTC = (totalTTC: string, pageOrder: boolean) => {
  const defineClass = () => {
    if (pageOrder) {
      return ' text-right font16 col-md-4 pr-0';
    }
    return ' font14 mb-1 ma0Mobile';
  };

  return (
    <div className={'bold black' + defineClass()}>
      {formatPrice(totalTTC)} &euro;
    </div>
  );
};

export const renderOptionModeReglement = (tabPayments: PaymentMethod[], orderPage: boolean,
                                          annulationIsPossible: string, annulationActivee: boolean, idPays: number = 1) => {
  const tabMethods = [];

  for (const paymentMethod of tabPayments) {
    if(paymentMethod?.pays_id == idPays) {
      tabMethods.push(
        <option value={defineValueForSelectOptionPayment(paymentMethod.label)}>
          {paymentMethod.label}
        </option>,
      );
    }
  }
  if (annulationIsPossible === 'Oui' && annulationActivee == true) {
    tabMethods.push(
      <option value="annulerCommande">
        Annuler cette commande </option>,
    );
  }

  return tabMethods;
};

export const renderCheque = (numCommande: string) => {
  return (
    <div>
      <p>
        Veuillez nous adresser votre chèque à l'ordre de <span className="bold">DESIGN'PARTNER SAS </span>
        et inscrire au dos du chèque votre numéro de commande :
        <span className="bold"> {renderNumCommande(numCommande)}</span>
      </p>
      <p>
        Envoyez le ensuite à cette adresse : </p>
      <div className="bold">
        <p>DESIGN'PARTNER</p>
        <p>BAT. HELIOS - Z.A. la Papillonnière</p>
        <p>Rue Yves Landegren</p>
        <p>14500 VIRE NORMANDIE</p>
      </div>
      <p>Votre commande sera prise en compte dès réception du chèque.</p>
    </div>
  );
};

const getPaymentLink = (order: Order) => {
  let link = '/www/MonCompte/paiement.php?idCommande=';
  if (order.ModeDeReglement === 'PayPal') {
    link = '/www/MonCompte/paiement-paypal.php?idCommande=';
  }
  link += order.idCommande + '&signature=' + order.Signature;

  return link;
};

const renderPayButton = (order: Order, orderPage: boolean) => {
  const defineModeReglement = () => {
    if (order.ModeDeReglement === 'Carte bancaire') {
      return 'CB';
    }

    return order.ModeDeReglement;
  };

  const defineClassContainer = () => {
    if (orderPage) {
      return 'mt-3';
    }
  };

  const defineClassButton = () => {
    if (orderPage) {
      return ' py-2 px-3 payBigButton';
    }

    return ' small py-1 px-2 small payButton d-flex align-items-center mx-auto w70';
  };

  if (parseInt(order.StatutCommande) < 3) {
    return (
      <div className={defineClassContainer()}>
        <a href={getPaymentLink(order)} target="_blank"
           className={'bold white bg-blue py-1 px-2 ' + defineClassButton()}>
          <Icons icon="credit_card" size={16} color="white"/>
          <span className="pl-1">Payer</span>
        </a>
      </div>
    );
  }

  if (parseInt(order.StatutCommande) !== 9) {
    return (
      <div className={defineClassContainer()}>
        <p className="black small bold">
          <Icons icon="done" size={10} color="#73ad22"/>
          <span className="pl-1">Payé par {defineModeReglement()}</span>
        </p>
      </div>
    );
  }
};

export const displayPayButton = (order: Order, orderPage: boolean) => {
  if (order.ModeDeReglement === 'Carte bancaire' || order.ModeDeReglement === 'PayPal') {
    return renderPayButton(order, orderPage);
  }
};

const renderDetailsPaymentModal = (order: Order, modalCheque: any, modalRIB: any) => {
  if (order.ModeDeReglement === 'Cheque' || order.ModeDeReglement === 'Chèque') {
    return modalCheque;
  }
  if (order.ModeDeReglement === 'Virement' || order.ModeDeReglement === 'Virement Administration') {
    return modalRIB;
  }
};

const renderDetailsPaymentButton = (order: Order, modalCheque: any, modalRIB: any, defineButtonAction: any) =>
{
  return (
    <div>
      {defineButtonAction}
      {renderDetailsPaymentModal(order, modalCheque, modalRIB)}
    </div>
  );
};

export const displayDetailsPaymentButton = (order: Order, renderModalCheque: any, renderModalRIB: any,
                                            defineButtonAction: any) => {
  /* if (order.ModeDeReglement === 'Virement' || order.ModeDeReglement === 'Virement Administration' ||
    order.ModeDeReglement === 'Cheque' || order.ModeDeReglement === 'Chèque') {
    return renderDetailsPaymentButton(order, renderModalCheque, renderModalRIB, defineButtonAction);
  } */
  return renderDetailsPaymentButton(order, renderModalCheque, renderModalRIB, defineButtonAction);
};

export const renderFileButton = (order: Order, pageOrder: boolean, activationNouvelUpload: boolean = false) => {
  const defineClassContainer = () => {
    if (pageOrder) {
      return 'text-center mr-3 containerFileBigButton';
    }
  };

  const defineLinkClass = () => {
    if (pageOrder) {
      return ' py-2 px-3 font16 fileBigButton d-none';
    }

    return ' px-2 fileButton d-flex align-items-center justify-content-center mx-auto';
  };

  const defineBgClass = () => {
    if (getShopRefInStorage() === 'DG') {
      return 'bg-orange';
    }  else if (getShopRefInStorage() === 'DT') {
      return 'bg-red-dt';
    } else if (getShopRefInStorage() === 'TH') {
      return 'bg-black';
    }
    return 'bg-blue';
  };

  if (parseInt(order.confirmationFichier) === 0 && parseInt(order.StatutCommande) < 6 && parseInt(order.cf) !== 1 && !order.AucunMarquage) {
    return (
      <div className={defineClassContainer()}>
        <Link to={`/files/${order.idCommande}`} className={'bold white w-75 ' + defineLinkClass() + ' ' + defineBgClass()}>
          <Icons icon="file_upload" size={16} color="white"/>
          <span className="pl-1">Envoi des fichiers</span>
        </Link>
      </div>
    );

  }
  if (!order.AucunMarquage && parseInt(order.confirmationFichier) === 1) {
    return (
      <div className={defineClassContainer() + ' texteFileButton'}>
        <Link to={`/files/${order.idCommande}`} className="black">
          <Icons icon="done" size={10} color="#73ad22"/>
          <span className="pl-1">Fichiers envoyés</span>
        </Link>
      </div>
    );
  }
};

const renderTrackingClaimLink = (idCommande: string, nbRetours: number) => {
  if (nbRetours >= 1) {
    const defineText = () => {
      if (nbRetours === 1) {
        return 'de la demande';
      }

      return 'des ' + nbRetours + ' demandes';
    };

    return (
      <div>
        <Link title="Suivi des réclamations" className="black" to={`/orders/${idCommande}/reclamations`}>
          <Icons icon="keyboard_arrow_right" size={10} color="black"/>
          <span>Suivi {defineText()} en cours</span>
        </Link>
      </div>
    );
    /*
     // TODO : Décommenter pour afficher ancienne page
     return (
     <div>
     <a href={'/www/MonCompte/retours.php?idCommande=' + idCommande} className="black">
     <Icons icon="keyboard_arrow_right" size={10} color="black" /> Suivi {defineText()} en cours
     </a>
     </div>
     );
     */
  }
};

const renderClaimLink = (idCommande: string, isPossible: boolean, hasGesteCommercial: boolean = false) => {
  let className = ' not-allowed';
  let title = 'Le délai de rétractation est dépassé';
  if (hasGesteCommercial) {
    title = 'La commande a déjà fait l\'objet d\'un geste commercial';
  }
  const boutique = getShopRefInStorage();
  let motif = 'réclamation';
  let to = '';

  if (boutique === 'MT') {
    motif = 'RETOUR / RECLAMATION';
  }
  if (isPossible) {
    className = '';
    title = 'Demande de ' + motif.toLowerCase();
    to = `/orders/${idCommande}/reclamation`;
  }

  return (
    <div>
      <Link title={title} className={'black ' + className} to={to} onClick={() => (!isPossible) ? alert(title) : ''}>
        <Icons icon="keyboard_arrow_right" size={10} color="black"/>
        <span>Demande de {motif.toUpperCase()}</span>
      </Link>
    </div>
  );

  // TODO : Décommenter pour afficher ancienne page
  /*return (
   <div>
   <a href={href} title={title} className={'black' + className}>
   <Icons icon="keyboard_arrow_right" size={10} color="black" />
   <span>Demande de {motif}</span>
   </a>
   </div>
   );*/
};

const renderContainerOptionsClaim = (idCommande: string, isPossible: boolean, nbRetours: number, PresenceGesteCommercial : boolean = false) => {
  const styleContainer = {
    display: 'none',
  };

  return (
    <div id={'containerOptionsClaim-' + idCommande} style={styleContainer} className="small mt-2 pt-1">
      {renderClaimLink(idCommande, isPossible, PresenceGesteCommercial)}
      {renderTrackingClaimLink(idCommande, nbRetours)}
    </div>
  );
};

const renderClaimOptionsButton = (statutCommande: string, idCommande: string) => {
  if (parseInt(statutCommande) === 8) {
    return (
      <div className="pt-1 pa0Mobile">
        <a href="#" title="Plus d'options" className="cursor-pointer btnPlusOptions text-secondary border rounded p-1"
           id={idCommande}
           onClick={event => showClaimOptions(idCommande, event)}>
          <span id={'signClaimOptions-' + idCommande}>+</span>
          <span className="pl-1">d'options</span>
        </a>
      </div>
    );
  }
};

const showClaimOptions = (idCommande: string, event: any) => {
  event.preventDefault();
  const div = document.getElementById('containerOptionsClaim-' + idCommande);
  const sign = document.getElementById('signClaimOptions-' + idCommande);

  if (div && sign) {
    if (div.style.display === 'none') {
      div.style.display = 'block';
      sign.innerText = '-';
    } else {
      div.style.display = 'none';
      sign.innerText = '+';
    }
  }
};

export const renderClaim = (order: Order) => {
  return (
    <div>
      {renderClaimOptionsButton(order.StatutCommande, order.idCommande)}
      {renderContainerOptionsClaim(order.idCommande, order.retour_possible, order.nb_retours, order.PresenceGesteCommercial)}
    </div>
  );
};

const defineInvoiceCreditLink = () => {
  const shopInfos = getShopInfosInStorage();

  if (shopInfos.Ref === 'DG' || shopInfos.Ref === 'DT' || shopInfos.Ref === 'TH') {
    return '/order/images/';
  }
  return '/www/MonCompte/images/';
}

export const renderInvoiceLink = (order: Order) => {
  if (parseInt(order.StatutCommande) === 7 || parseInt(order.StatutCommande) === 8) {
    const shopRef = getShopRefInStorage();

    let url = `/www/MonCompte/FACTURE-${formatNumCommande(order.numCommande)}_${order.Signature}.pdf`;
    if (shopRef == 'DG' || shopRef == 'DT' || shopRef == 'TH') {
      url = `${getHostApi()}/customers/${getUserId()}/orders/${order.idCommande}/bill/${order.numero_facture}.pdf?xsrf=${localStorage.getItem('xsrfToken')}`;
    }

    return (
      <a target="_blank" href={url} className="black">
        <img height="12px" src={defineInvoiceCreditLink() + 'icone_pdf.gif'} alt="icone pdf"/>
        <span className="pl-1">Facture n°{order.numero_facture}</span>
      </a>
    );
  }
};

const renderContainerInvoiceLink = (order: Order) => {
  return (
    <div className="d-flex align-items-center">
      {renderInvoiceLink(order)}
    </div>
  );
};

export const displayInvoice = (order: Order) => {
  if (parseInt(order.Facture) === 1) {
    return renderContainerInvoiceLink(order);
  }
};

export const displayRefundInformations = (order: any) => {
  if (parseInt(order.etat.idEtat) === 9 && order.EnFabrication !== '0000-00-00 00:00:00' && (order.ModeDeReglement === 'PayPal' || order.ModeDeReglement === 'Carte bancaire')) {
    if (order.logs.length > 0) {
      for (const log of order.logs) {
        if (parseInt(log.commentaire_client_child_tag_id) === 11 || parseInt(log.commentaire_client_child_tag_id) === 13) {
          return (
              <div className="d-flex align-items-center">
                <div className="italic  pa0Mobile lightgrey">
                  Remboursée le {moment(log.DateHeure).format('DD/MM/YYYY')}
                </div>
              </div>
          );
        }
      }
      return (
          <div className="d-flex align-items-center">
            <div className="italic pa0Mobile lightgrey">
              En cours de remboursement
            </div>
          </div>
      );
    }
  }
}

export const renderCreditLink = (credit: any, order: Order) => {
  if (parseInt(order.StatutCommande) === 7 || parseInt(order.StatutCommande) === 8) {
    const shopRef = getShopRefInStorage();
    let url = '/www/MonCompte/AVOIR-' + formatNumCommande(order.numCommande) + '_' + credit.idAvoirClient + '_' + order.Signature + '.pdf';
    if (shopRef == 'DG' || shopRef == 'DT') {
      url = `${getHostApi()}/customers/${getUserId()}/orders/${order.idCommande}/credit/${credit.idAvoirClient}.pdf?xsrf=${localStorage.getItem('xsrfToken')}`;
    }
    return (
      <a target="_blank" href={url} className="black">
        <img height="12px" src={defineInvoiceCreditLink() + 'icone_pdf.gif'} alt="icone pdf"/>
        <span className="pl-1">{credit.numero_avoir}&nbsp;
          {order.sav != '1' &&
          <span  className="italic grey font11">{credit.date_refund ? `Remboursé le ${moment(credit.date_refund).format("DD/MM/YYYY [à] HH[h]mm")}` : "En cours de remboursement"}</span>
          }
        </span>
      </a>
    );
  }
};

export const renderCreditLinks = (order: Order) => {
  if (order.credits) {
    const renderListCredits = order.credits.map((credit: Credit, index) => {
      return (
        <div className="d-flex align-items-center" key={credit.numero_avoir}>
          {renderCreditLink(credit, order)}
        </div>
      );
    });

    return renderListCredits;
  }
};

export const renderTrackingLink = (url: string, numColis: string, cf: string, colis: any) => {
  if(colis && colis.length > 0) {
    const tabColis = [];
    for (const item of colis) {
      tabColis.push (
        <div>
        <a title="Suivre mon colis" target="_blank" href={item.tracking}>
          <img src={defineInvoiceCreditLink() + 'ic-truck.png'} alt="icone transport"/>
          &nbsp;{item.numero}
        </a>
        </div>
      );
    }
    return tabColis;
  }
  else if (url != '' && numColis != '') {
    return (
      <a title="Suivre mon colis" target="_blank" href={url}>
        <img src={defineInvoiceCreditLink() + 'ic-truck.png'} alt="icone transport"/>
        &nbsp;{numColis}
      </a>
    );
  }
};

export const renderContainerTrackingLink = (url: string, numColis: string, cf: string, statutCmd: string, colis: any) => {
  if (parseInt(cf) !== 1 && parseInt(statutCmd) === 8) {
    return (
      <div>
        {renderTrackingLink(url, numColis, cf, colis)}
      </div>
    );
  }
};

export const renderTitleH1 = (icon: string, text: string, textSecondary: string | null = null) => {
  return (
    <h1 className="text-uppercase bold font30 font22 black mb-2 d-flex align-items-center">
      <Icons icon={icon} size={20} color={getBoutiqueColor()}/>
      <span className="pl-2">{text}</span> <span className="text-lowercase grey small pl-2"> {textSecondary}</span>
    </h1>
  );
};

export const getItemLinkHref = (article: any) => {
  const shopInfos = getShopInfosInStorage();
  let link: string|undefined = '';
  /** Pour les tests : */
  // shopInfos.Ref = "MT";

  if (article.produit) {
    if (shopInfos.Ref === 'TO') {
      link = '/fiche-produit.php?ref=' + article.produit.Reference + '&idcouleur=' + article.couleur.idCouleursArticles;

      if(article.produit.link) {
        link = article.produit.link + '?idcouleur=' +
          article.couleur.idCouleursArticles;
      }
    } else if (shopInfos.Ref === 'TE') {
      /** A finir avec l'identifiant de la catégorie  */
      link = '/la_gamme.php?idcategorie=' + '0' + '&idcouleur=' + article.couleur.idCouleursArticles + '&reference='
        + article.produit.Reference;
      if (article.links.product.fr) {
        link = article.links.product.fr;
      }
    } else if (shopInfos.Ref === 'ME') {
      /** A finir avec l'identifiant de la catégorie  */
      link = undefined;
    } else if ((shopInfos.Ref === 'DG' || shopInfos.Ref === 'MT' || shopInfos.Ref === 'DT') && article.links && article.links.product &&
      article.links.product.fr) {
      link = article.links.product.fr;
      if (link && window.location.hostname.includes('deixo.com')) {
        link = link.replace('lamaisonduteeshirt.com', 'deixo.com');
      }
      // link = '/p-' + article.produit.titles['fr'].split(' ').join('-').toLowerCase() + '-' + article.produit.Reference;
    }
  }


  return link;
};

export const renderImgLinkME = (creationId: string, numFrame: string) => {
  let frame = numFrame;
  let url = '/images/aplats/web/' + creationId + '.jpg';
  if (frame) {
    if (frame.length === 1) {
      frame = '0' + frame;
    }
    url = '/images/3d/' + creationId + '_' + frame + '.jpg';
  }

  return url;
};

export const renderImgLinkDT = (creationId: string) => {
  const boutiqueId = getShopInfosInStorage() ? getShopInfosInStorage().idBoutique : 11;
  const url = `${getHostApi()}/images/upload/${`${boutiqueId}-${creationId}`}/miniatures/web/${creationId}.png`;
  return url;
};

export const renderImgLink = (link: any) => {
  let lienImg = '';
  if (link.images['128x128']) {
    lienImg = link.images['128x128']['1']?.lien ? link.images['128x128']['1'].lien : link.images['128x128'][0];
  }
  else if (link.images_principales['128x128']) {
    lienImg = link.images_principales['128x128']?.lien ? link.images_principales['128x128'].lien : link.images_principales['128x128'];
  }
  else if (link.images['270x270']) {
    lienImg = link.images['270x270']['1']?.lien ? link.images['270x270']['1'].lien : link.images['270x270'][0];
  }
  else if (link.images['550x550']) {
    lienImg = link.images['550x550']['1']?.lien ? link.images['550x550']['1'].lien : link.images['550x550'][0];
  }
  else if (link.images['200x300']) {
    lienImg = link.images['200x300']['1']?.lien ? link.images['200x300']['1'].lien : link.images['200x300'][0];
  }
  return lienImg;
};

export const renderProductImage = (
  panier: any,
  modal: any | null = null,
  onClick: (event: React.MouseEvent<HTMLDivElement>) => void,
  order: any | null = null,
  enabledPostProcessing: boolean = false
) => {
  let imgLinkDT = '';
  let imgLinkME = '';
  const shopRef = getShopInfosInStorage().Ref;
  if(shopRef == 'DT' && Array.isArray(panier.marquages)) {
    const filename = `preview_${panier.creation_id}-${panier.marquages[0].surface_emplacement_id}.png`;
    imgLinkDT = `${getHostApi()}/customers/${order.Client_idClient}/orders/${order.idCommande}/image-files?nom=${filename}&numCommande=${order.numCommande}&path=travail.auto/miniatures/&validated=true&xsrf=${localStorage.getItem('xsrfToken')}`;
  }  
  
  if(shopRef == 'ME') {
    const filename = `${panier.creation_id}.webp`;
    imgLinkME = `${getHostApi()}/customers/${order.Client_idClient}/orders/${order.idCommande}/image-files?nom=${filename}&numCommande=${order.numCommande}&path=textures/&validated=true&xsrf=${localStorage.getItem('xsrfToken')}`;
  }

  return (
    <div className="col-md-3">
      <div className="h100">
        {shopRef != 'ME' && shopRef != 'DT' ? (
          <a href={getItemLinkHref(panier.article)}>
            <img src={renderImgLink(panier.article.links)} width="128" height="auto" />
          </a>
        ) : (
          <div onClick={panier.marquage === "vierge" ? undefined : onClick} className={`h100 ${panier.marquage !== "vierge" && "cursor-pointer"}`}>
            {shopRef == 'ME' ? (
              <div className="h100">
                <ProductViewer
                  glbUrl={`/model/${panier.article.produit.idProduits}.xs3p`}
                  colorId={parseInt(panier.article.couleur.idCouleursArticles)}
                  textureUrl={imgLinkME}
                  primaryColor="#FFF"
                  disabledCameraControl={true}
                  enabledPostProcessing={enabledPostProcessing}
                />
              </div>
              ) : (
              <img src={panier.marquage === "vierge" ? renderImgLink(panier.article.links) : imgLinkDT} alt="" width="128" height="auto"/>
              )}
          </div>
        )}
      </div>
      {modal}
    </div>
  );
};

export const renderCol = (text: any, size: string) => {
  return (<div className={'text-center col-md-' + size}>{text}</div>);
};

export const inputColorWhenError = (name: string) => {
  const input = document.getElementsByName(name).item(0);

  if (input) {
    input.style.borderColor = 'red';
  }

  // input.scrollIntoView();
};

export const inputColorWhenNoError = (name: string) => {
  const input = document.getElementsByName(name).item(0);

  if (input) {
    input.style.borderColor = '#bbbbbb';
  }

  // window.scrollTo(0, 0);
};

export const formatNumTva = (numTva: string, codePays: string): string => {
  return numTva.replace(/ /g, '')
      .replace(/\./g, '')
      .replace(/-/g, '')
      .replace(codePays, '')
      .replace(codePays.toLowerCase(), '');
}